import { CommonModule as NgCommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { OmsLocalizeTimeMessageContentPropPipe } from "./oms-localize-time-message-content-prop.pipe";
import { OmsLocalizeTimeDirective } from "./oms-localize-time.directive";

@NgModule({
	imports: [NgCommonModule],
	declarations: [OmsLocalizeTimeDirective, OmsLocalizeTimeMessageContentPropPipe],
	exports: [OmsLocalizeTimeDirective, OmsLocalizeTimeMessageContentPropPipe],
})
export class OmsLocalizeTimeModule {}
